import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Link,
  withRouter,
} from 'react-router-dom';
import { Col } from 'reactstrap';
import classnames from 'classnames';
import { useIntl } from 'react-intl';

import {
  accountUsageLock,
  subscriptionExpired,
} from '../helpers/App';

const AccountUsageInfo = ({ profile }) => {
  const intl = useIntl();

  if (!profile) {
    return null;
  }

  const { client } = profile;
  if (!client) {
    return null;
  }

  if (!accountUsageLock(client) && !subscriptionExpired(client)) {
    return null;
  }

  let message = '';
  let buttonMessage = '';

  if (accountUsageLock(client)) {
    message = intl.formatMessage({
      defaultMessage: 'You have reached your storage limit',
    });
    buttonMessage = intl.formatMessage({
      defaultMessage: 'Upgrade now',
    });
  }

  if (subscriptionExpired(client)) {
    message = intl.formatMessage({
      defaultMessage: 'Your subscription expired',
    });
    buttonMessage = intl.formatMessage({
      defaultMessage: 'Update your subscription',
    });
  }

  return (
    <div className={classnames('account-usage-info-bar center', { 'subscription-expired': (accountUsageLock(client) || subscriptionExpired(client)) })}>
      <Col>
        <h5>
          {message}
        </h5>
        {profile.is_admin && (
          <Link
            className="btn btn-info"
            to="/admin/settings/subscription"
          >
            {buttonMessage}
          </Link>
        )}
      </Col>
    </div>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
});

AccountUsageInfo.propTypes = {
  profile: PropTypes.object,
};

AccountUsageInfo.defaultProps = {
  profile: null,
};

export default withRouter(connect(mapStateToProps)(AccountUsageInfo));
